import { type FC, type HTMLAttributes, type ReactNode, useEffect, useRef } from 'react'
import { useTheme } from '@mui/material/styles'

import AppBar from '@DS/components/navigation/appBar/AppBar'

import { useModalPageInfo } from './ModalContext'
import * as styles from './styles'

export type ModalPageProps = {
  headerTitle: string
  children?: ReactNode
  onBackButtonClick?: VoidFunction
} & HTMLAttributes<HTMLDivElement>

const ModalPage: FC<ModalPageProps> = ({ headerTitle, children, onBackButtonClick, ...rest }) => {
  const theme = useTheme()
  const { isBackIconDisplayed, onBackIconClick, onClose } = useModalPageInfo()
  const modalPageContentRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    modalPageContentRef.current?.focus()
  }, [])

  return (
    <>
      {headerTitle && (
        <AppBar
          title={headerTitle}
          isInModal
          onCloseButtonClick={onClose}
          onBackButtonClick={isBackIconDisplayed ? onBackButtonClick || onBackIconClick : undefined}
        />
      )}

      <div css={styles.contentWrapper(theme)} ref={modalPageContentRef} tabIndex={-1} {...rest}>
        {children}
      </div>
    </>
  )
}

export default ModalPage
